module.exports = __webpack_public_path__ + "static/media/21.d0f5a6b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/21.png
// module id = 874
// module chunks = 0